import React from 'react'
import { Typography, Button, CardMedia, Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface HomePageBannerItemProps {
  image: string
  text: string
  url: string | null
}

const useStyles = makeStyles()(theme => ({
  notifierContainer: {
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    aspectRatio: '12',
    [theme.breakpoints.down('sm')]: {
      height: '15vh',
      aspectRatio: 'auto',
    },
  },
  notifierTitle: {
    width: '100%',
    color: theme.palette.common.white,
    fontWeight: 500,
    fontSize: '15px',
    textAlign: 'center',
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.light,
    padding: theme.spacing(4),
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(4),
    [theme.breakpoints.only('md')]: {
      padding: theme.spacing(0, 2),
      marginRight: theme.spacing(2),
    },
  },
}))

const HomePageBannerItem: React.FC<HomePageBannerItemProps> = ({ image, text, url }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  return (
    <CardMedia className={classes.notifierContainer} image={image}>
      <Box className={classes.notifierContainer}>
        <Typography className={classes.notifierTitle} dangerouslySetInnerHTML={{ __html: text }} />
        {url && (
          <Button
            variant="contained"
            size="large"
            className={classes.button}
            onClick={() => {
              window.open(url, '_blank')
            }}
          >
            {t('shop.notifier.more-info')}
          </Button>
        )}
      </Box>
    </CardMedia>
  )
}

export default HomePageBannerItem
